import { Title } from '../../components/Title/Title';
import { Topbar } from '../../components/Topbar/Topbar';
import { Badge, Button, Container, Form, Modal, Table } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useEffect, useState } from 'react';
import { CSVParser } from '../../components/CSVParser/CSVParser';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { formatSecondsTimestamp } from '../../utils/utils';
import { differenceInMinutes } from 'date-fns';
import { Copyable } from '../../components/Copyable/Copyable';
import { WithTooltip } from '../../components/WithTooltip/WithTooltip';
import { useDetectChanges } from '../../../hooks/useDetectChanges';
import styles from './Sicuramente.module.scss';

const FlowSicuramenteComponent = () => {
  const { getCustomFlowUsers, massiveCustomSignup, userDataFmt, getFadCourses, getCourseStatus, handleCustomUser } = useFirebase();
  const [users, setUsers] = useState([]);
  const [usersCsvParserOpen, setUsersCsvParserOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showPreview, setShowPreview] = useState(null);
  const [userSignupCommit, setUserSignupCommit] = useState(false);
  const [message, setMessage] = useState('');
  const [loadingRow, setLoadingRow] = useState<string>(null);

  const [handling, setHandling] = useState<{ email?: string; id?: string }>({});
  const [handlingFlow, setHandlingFlow] = useState<'sub' | 'courses'>(null);
  const [userCourses, setUserCourses] = useState<any[]>([]);
  const [subscribingPlan, setSubscribingPlan] = useState<{ name?: string; id?: string }>({});
  const [handleUserCommit, setHandleUserCommit] = useState(false);

  const [isAddSingleUserModalOpen, setIsAddSingleUserModalOpen] = useState(false);
  const [userEmail, setUserEmail] = useState<string>('');
  const [userName, setUserName] = useState<string>('');
  const [userSurname, setUserSurname] = useState<string>('');
  const [userPassword, setUserPassword] = useState<string>('');

  const detectChanges = useDetectChanges();

  const isDev = window.location.href.includes('tootor-dev') || window.location.href.includes('tootor-stage') || process.env.NODE_ENV == 'development';
  const stripeProductIds = {
    annuale: isDev ? 'prod_Jkm80qDvLOSniE' : 'prod_K3AygG9OQQtLbl',
    annualeConEcm: isDev ? 'prod_T1QwpgZ9sBjici' : 'prod_TJoKzNQNtWDCuX',
  };

  const getUsers = () => {
    setLoading(true);
    getCustomFlowUsers()
      .then((users) => {
        setUsers(
          users.data.map((row) => ({
            id: row.id,
            email: row.email,
            nome: row.profile.formData.nome,
            cognome: row.profile.formData.cognome,
            created: Math.floor(row.created / 1000),
            lastLogin: row.lastLogin && differenceInMinutes(new Date(row.lastLogin), new Date(row.created)) > 1 ? Math.floor(row.lastLogin / 1000) : 0,
            sub: row.sub,
            courses: row.courses,
          }))
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (userSignupCommit) {
      setLoading(true);
      massiveCustomSignup(showPreview.map((u) => ({ ...u, categoriaProfessionale: 'odontoiatra' })))
        .then(({ code, alreadyExisting, successfullyCreated, nonExistent }) => {
          let message: string = '';

          if (code) message += code;
          else {
            message += 'Operazione completata.\n';

            if (nonExistent.length) {
              message += `\nI seguenti utenti non hanno una mail valida e non verranno aggiunti:\n`;
              for (const email of nonExistent) {
                message += `• ${email}\n`;
              }
            }

            if (alreadyExisting.length) {
              message += `\nI seguenti utenti sono già iscritti in piattaforma e non verranno aggiunti:\n`;
              for (const email of alreadyExisting) {
                message += `• ${email}\n`;
              }
            }

            if (successfullyCreated.length) {
              message += `\nI seguenti utenti sono stati REGISTRATI alla piattaforma:\n`;
              for (const user of successfullyCreated) {
                message += `• ${user.email} (${user.nome} ${user.cognome}) ${user.password}\n`;
              }
              message += `SALVARE LA PASSWORD SE NECESSARIO, è l'ultima volta che potrà essere visualizzata!\n`;
            }
          }

          setMessage(message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setShowPreview(null);
      getUsers();
    }
  }, [userSignupCommit]);

  useEffect(() => {
    if (handleUserCommit) {
      setLoading(true);
      handleCustomUser(handling.id, {
        stripeProductId: handlingFlow == 'sub' ? subscribingPlan.id : null,
        courseSlugs: handlingFlow == 'courses' ? userCourses.filter((c) => c.selected).map((c) => c.slug) : null,
      })
        .then(({ code, failedSubscriptions, failedEnrolledUsers, successfullyEnrolledUsers }) => {
          let message: string = '';

          if (code) message += code;
          else {
            message += 'Operazione completata.\n';

            if (failedSubscriptions.length) {
              message += `\nI seguenti utenti NON sono stati ABBONATI alla piattaforma:\n`;
              for (const user of failedSubscriptions) {
                message += `• ${user.email} - ${user.reason}\n`;
              }
            }

            if (failedEnrolledUsers.length) {
              message += `\nI seguenti utenti NON sono stati ISCRITTI ai corsi:\n`;
              for (const user of failedEnrolledUsers) {
                message += `• ${user.email} - ${user.reason}\n`;
              }
            }

            if (successfullyEnrolledUsers.length) {
              message += "\nPotrebbe essere necessario attendere qualche minuto per finalizzare l'iscrizione ai corsi.";
            }
          }

          setMessage(message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setHandling({});
      setSubscribingPlan({});
      setUserCourses([]);
      setHandlingFlow(null);
      getUsers();
    }
  }, [handleUserCommit]);

  return (
    <>
      <Title>Sicuramente</Title>

      <Topbar />

      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          <div className={'display-4'}>Sicuramente</div>
        </div>

        <div className={'mt-3'}>
          <Button variant={'outline-primary'} className={'mr-2'} onClick={() => setUsersCsvParserOpen(true)} disabled={loading || !!loadingRow}>
            Aggiungi utenti da CSV
          </Button>
          <Button variant={'outline-primary'} onClick={() => setIsAddSingleUserModalOpen(true)} disabled={loading || !!loadingRow}>
            Aggiungi utente singolo
          </Button>
        </div>

        <Table striped bordered variant={'dark'} className={'mt-4 small'} size={'sm'}>
          <thead>
            <tr>
              <th className={styles.nowrap}>Utente</th>
              <th className={styles.nowrap}>Nome</th>
              <th className={styles.nowrap}>Dettagli</th>
              <th className={styles.nowrap}>Corsi</th>
              <th className={styles.nowrap}>Abbonamento</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={99} className={'text-center'}>
                  Caricamento&hellip;
                </td>
              </tr>
            )}
            {!loading && (
              <>
                {!users.length && (
                  <tr>
                    <td colSpan={99} className={'text-center'}>
                      Nessun risultato.
                    </td>
                  </tr>
                )}
                {users.map((user) => (
                  <tr key={user.email} className={`${styles.customFlowRow} ${loadingRow == user.email ? styles.rowDisabled : ''}`}>
                    <td className={styles.nowrap}>
                      <div>{user.email}</div>
                      {userDataFmt.admin && <Copyable text={user.id} />}
                    </td>
                    <td className={styles.nowrap}>
                      {user.cognome} {user.nome}
                    </td>
                    <td className={styles.nowrap}>
                      <div>
                        <WithTooltip text={'Creato il'} big={false}>
                          <span>{formatSecondsTimestamp(user.created, 'dd/MM/Y HH:mm')}</span>
                        </WithTooltip>
                      </div>
                      <div>
                        <WithTooltip text={'Ultimo accesso'} big={false}>
                          <span className={user.lastLogin ? '' : 'text-secondary font-italic'}>
                            {user.lastLogin ? formatSecondsTimestamp(user.lastLogin, 'dd/MM/Y HH:mm') : 'Mai'}
                          </span>
                        </WithTooltip>
                      </div>
                    </td>
                    <td>
                      <div>
                        {user.courses.map((c, i, a) => (
                          <div
                            key={c.fad_course_id}
                            className={styles.courseRow}
                            style={{
                              background: (() => {
                                if (c.metadata?.CUSTOM_SIGNUP_FLOW != 'SICURAMENTE') return undefined;
                                if (c.is_complete == 1) return '#2c5d63';
                                if (!c.completement_percentage || c.completement_percentage == 0) return '#45171d';
                                return `linear-gradient(to right, #00204a ${c.completement_percentage || 0}%, #233142 ${c.completement_percentage || 0}%)`;
                              })(),
                            }}
                          >
                            <span className={c.metadata?.CUSTOM_SIGNUP_FLOW == 'SICURAMENTE' ? '' : 'text-secondary'}>
                              ({c.fad_course_id}) {c.fad_course_name}
                            </span>
                            {c.metadata?.CUSTOM_SIGNUP_FLOW == 'SICURAMENTE' ? (
                              <span>
                                {c.is_complete == 1 ? (
                                  formatSecondsTimestamp(Math.floor(new Date(c.complete_moment).getTime() / 1000), 'dd/MM/yyyy')
                                ) : (
                                  <>{c.completement_percentage || 0}%</>
                                )}
                              </span>
                            ) : (
                              <WithTooltip text={"Operazione effettuata in autonomia dall'utente"} big={false}>
                                <Badge variant={'secondary'} pill>
                                  ⚠️
                                </Badge>
                              </WithTooltip>
                            )}
                          </div>
                        ))}
                        {!user.courses.length && <span className={'text-secondary font-italic'}>Nessuna iscrizione</span>}
                      </div>
                      {(!user.sub || user.sub.product.stripe_metadata_IS_ECM_PACKAGE != 'yes' || !!user.courses.length) && (
                        <div>
                          {!!user.courses.length && (
                            <>
                              <Button
                                as={Badge}
                                variant={loading || !!loadingRow ? 'secondary' : 'primary'}
                                style={{ pointerEvents: loading || !!loadingRow ? 'none' : 'auto' }}
                                onClick={() => {
                                  setLoadingRow(user.email);
                                  getCourseStatus(
                                    user.id,
                                    user.courses.map((c) => c.fad_course_id)
                                  )
                                    .then(({ data }) => {
                                      if (!data?.length) return;
                                      for (const elt of data) {
                                        const id = elt.courseId;
                                        const row = user.courses.find((c) => c.fad_course_id == id);
                                        row.is_complete = elt.is_complete;
                                        row.complete_moment = elt.complete_moment;
                                        row.completement_percentage = elt.completement_percentage;
                                        row.completion_seconds = elt.completion_seconds;
                                      }
                                      detectChanges();
                                    })
                                    .finally(() => {
                                      setLoadingRow(null);
                                    });
                                }}
                              >
                                aggiorna
                              </Button>{' '}
                            </>
                          )}
                          {(!user.sub || user.sub.product.stripe_metadata_IS_ECM_PACKAGE != 'yes') && (
                            <Button
                              as={Badge}
                              variant={loading || !!loadingRow ? 'secondary' : 'primary'}
                              style={{ pointerEvents: loading || !!loadingRow ? 'none' : 'auto' }}
                              onClick={() => {
                                setLoadingRow(user.email);
                                getFadCourses(user.id)
                                  .then(({ data }) => {
                                    setHandling(user);
                                    setUserCourses(data);
                                    setSubscribingPlan({});
                                    setHandlingFlow('courses');
                                  })
                                  .finally(() => {
                                    setLoadingRow(null);
                                  });
                              }}
                            >
                              iscrivi
                            </Button>
                          )}
                        </div>
                      )}
                    </td>
                    <td>
                      <div>
                        {!user.sub && (
                          <span className={`text-secondary font-italic ${styles.nowrap}`}>
                            Nessun abbonamento attivo
                          </span>
                        )}
                        {user.sub && (
                          <div>
                            {user.sub.metadata?.CUSTOM_SIGNUP_FLOW != 'SICURAMENTE' && (
                              <WithTooltip text={"Operazione effettuata in autonomia dall'utente"} big={false}>
                                <Badge variant={'secondary'} pill className={'mr-1'}>
                                  ⚠️
                                </Badge>
                              </WithTooltip>
                            )}
                            <span>{user.sub.product.name}</span>
                          </div>
                        )}
                      </div>
                      {!user.sub && (
                        <div>
                          <span>Attiva:</span>{' '}
                          <Button
                            as={Badge}
                            onClick={() => {
                              setHandling(user);
                              setSubscribingPlan({ name: 'Annuale', id: stripeProductIds.annuale });
                              setUserCourses([]);
                              setHandlingFlow('sub');
                            }}
                          >
                            annuale
                          </Button>{' '}
                          <Button
                            as={Badge}
                            onClick={() => {
                              setHandling(user);
                              setSubscribingPlan({ name: 'Annuale + ECM', id: stripeProductIds.annualeConEcm });
                              setUserCourses([]);
                              setHandlingFlow('sub');
                            }}
                          >
                            ann+ECM
                          </Button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </Table>
      </Container>

      <Footer />

      <Modal
        show={handleUserCommit}
        onHide={() => {
          setHandling({});
          setSubscribingPlan({});
          setUserCourses([]);
          setHandleUserCommit(false);
        }}
        size={'xl'}
        scrollable={true}
        backdrop={'static'}
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{loading ? <>Attendere&hellip;</> : 'Riepilogo'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && <FullscreenLoader fullscreen={false} />}
          {!loading && <div className={styles.messageText}>{message}</div>}
        </Modal.Body>
        {!loading && (
          <Modal.Footer>
            <Button variant={'secondary'} onClick={() => setHandleUserCommit(false)}>
              Chiudi
            </Button>
          </Modal.Footer>
        )}
      </Modal>

      <Modal
        show={!!handling.id && handlingFlow == 'sub' && !handleUserCommit}
        onHide={() => {
          setHandling({});
          setSubscribingPlan({});
          setUserCourses([]);
          setHandlingFlow(null);
        }}
        backdrop={'static'}
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Attivazione abbonamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Stai per attivare l'abbonamento <strong>{subscribingPlan.name}</strong> per l'utente {handling.email}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant={'primary'} onClick={() => setHandleUserCommit(true)}>
            Conferma
          </Button>
          <Button
            variant={'secondary'}
            onClick={() => {
              setHandling({});
              setSubscribingPlan({});
              setUserCourses([]);
              setHandlingFlow(null);
            }}
          >
            Annulla
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!handling.id && handlingFlow == 'courses' && !handleUserCommit}
        size={'lg'}
        onHide={() => {
          setHandling({});
          setSubscribingPlan({});
          setUserCourses([]);
          setHandlingFlow(null);
        }}
        backdrop={'static'}
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Iscrizione corsi per {handling.email}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {userCourses.map((c) => (
            <Form.Check
              key={c.id}
              type={'checkbox'}
              id={c.slug}
              disabled={!c.is_buyable}
              checked={!c.is_buyable || !!c.selected}
              onChange={(e) => {
                c.selected = e.target.checked;
                detectChanges();
              }}
              label={
                <>
                  ({c.id}) {c.name}
                </>
              }
            />
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant={'primary'} disabled={!userCourses.some((c) => c.selected)} onClick={() => setHandleUserCommit(true)}>
            Conferma
          </Button>
          <Button
            variant={'secondary'}
            onClick={() => {
              setHandling({});
              setSubscribingPlan({});
              setUserCourses([]);
              setHandlingFlow(null);
            }}
          >
            Annulla
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={userSignupCommit}
        onHide={() => {
          setShowPreview(null);
          setUserSignupCommit(false);
        }}
        size={'xl'}
        scrollable={true}
        backdrop={'static'}
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{loading ? <>Attendere&hellip;</> : 'Riepilogo'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && <FullscreenLoader fullscreen={false} />}
          {!loading && <div className={styles.messageText}>{message}</div>}
        </Modal.Body>
        {!loading && (
          <Modal.Footer>
            <Button variant={'secondary'} onClick={() => setUserSignupCommit(false)}>
              Chiudi
            </Button>
          </Modal.Footer>
        )}
      </Modal>

      <Modal show={!!showPreview && !userSignupCommit} onHide={() => setShowPreview(null)} size={'lg'} scrollable={true}>
        <Modal.Header closeButton>
          <Modal.Title>Anteprima</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Verranno registrati i seguenti utenti:</p>
          <Table striped bordered size={'sm'} className={'mb-0'}>
            <thead>
              <tr>
                <th>Email</th>
                <th>Nome</th>
                <th>Cognome</th>
                <th>Password</th>
              </tr>
            </thead>
            <tbody>
              {showPreview &&
                showPreview.map((row) => (
                  <tr key={row.email}>
                    <td>{row.email}</td>
                    <td>{row.nome}</td>
                    <td>{row.cognome}</td>
                    <td className={row.password ? '' : 'text-secondary font-italic'}>{row.password || 'autogenerata'}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant={'primary'} onClick={() => setUserSignupCommit(true)}>
            Conferma
          </Button>
          <Button variant={'secondary'} onClick={() => setShowPreview(null)}>
            Annulla
          </Button>
        </Modal.Footer>
      </Modal>

      {usersCsvParserOpen && (
        <CSVParser
          show={usersCsvParserOpen}
          onHide={() => setUsersCsvParserOpen(false)}
          parser={'users-flow'}
          exampleHeaders={['email', 'nome', 'cognome', 'password']}
          onRowsReady={(rows) => {
            if (rows?.length) {
              setShowPreview(rows);
            }
          }}
        />
      )}

      {isAddSingleUserModalOpen && (
        <Modal show={isAddSingleUserModalOpen} onHide={() => setIsAddSingleUserModalOpen(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Aggiungi nuovo utente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className={styles.singleUserField}>
              <Form.Label>Email Utente</Form.Label>
              <Form.Control type="text" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} />
            </Form.Group>
            <Form.Group className={styles.singleUserField}>
              <Form.Label>Nome</Form.Label>
              <Form.Control type="text" value={userName} onChange={(e) => setUserName(e.target.value)} />
            </Form.Group>
            <Form.Group className={styles.singleUserField}>
              <Form.Label>Cognome</Form.Label>
              <Form.Control type="text" value={userSurname} onChange={(e) => setUserSurname(e.target.value)} />
            </Form.Group>
            <Form.Group className={styles.singleUserField}>
              <Form.Label>Password (facoltativo)</Form.Label>
              <Form.Control type="text" value={userPassword} onChange={(e) => setUserPassword(e.target.value)} />
              <Form.Text>
                Lasciare il campo vuoto per generare una password casuale.{' '}
                <strong>
                  Se si sceglie di inserire una password, <u>assicurarsi che sia lunga almeno 6 caratteri.</u>
                </strong>
              </Form.Text>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <div className={'w-100 d-flex justify-content-end'}>
              <Button
                size={'sm'}
                variant="outline-secondary"
                className={'mr-2'}
                onClick={() => {
                  setIsAddSingleUserModalOpen(false);
                  setUserEmail('');
                  setUserName('');
                  setUserSurname('');
                  setUserPassword('');
                }}
              >
                Annulla
              </Button>
              <Button
                size={'sm'}
                onClick={() => {
                  setShowPreview([
                    {
                      email: userEmail,
                      nome: userName,
                      cognome: userSurname,
                      password: userPassword,
                    },
                  ]);
                  setIsAddSingleUserModalOpen(false);
                  setUserEmail('');
                  setUserName('');
                  setUserSurname('');
                  setUserPassword('');
                }}
              >
                Aggiungi
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export { FlowSicuramenteComponent as FlowSicuramente };
